// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-brightcove-video .video-js .vjs-big-play-button {\n  width: 3.75rem;\n  height: 3.75rem;\n  line-height: 3.5625rem;\n  left: 50%;\n  top: 50%;\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
